import React from 'react'
import { RouteConfig } from 'react-router-config'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import { Redirect } from 'react-router'

const routes: RouteConfig[] = [
  {
    path: '/track',
    component: Blank,
    menuTitle: 'menu.trackCenter',
    routes: [
      {
        path: '/setting',
        component: withAsync(() => import(/* webpackChunkName: "TrackSettings" */ '@/containers/TrackSettings')),
        menuTitle: 'subscribe.trackingSetting.name',
        exact: true,
        permissionCode: 'track:setting',
      },
      {
        path: '/',
        component() {
          return <Redirect to="/track/setting" />
        },
        exact: true,
      },
    ],
  },
]

export default routes
